export interface AssignmentProgressLike {
  score?: number | null;
  timeAccumulator?: number | null;
  startDate?: string | null;
  completionDate?: string | null;
}

/**
 * Whether the student has actually worked on an assigned course/section. A progress
 * row exists from the moment of assignment, so its presence alone means nothing.
 * Mirrors hasCourseStarted (Course/utilities/courseProgressState).
 */
export function hasStartedProgress(
  progress: AssignmentProgressLike | null | undefined,
): boolean {
  return Boolean(
    progress?.startDate ||
    progress?.completionDate ||
    (progress?.timeAccumulator || 0) > 0,
  );
}
